import { connect } from 'react-redux';
import { stepDialogUpdate } from '../../../actions';
import MessageContent from './MessageContent';

const mapStateToProps = ({ stepDialog }) => {
    return {
        step: stepDialog.step,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onChange: (id, value) => {
        dispatch(stepDialogUpdate({ [id]: value }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageContent);
